module.exports = __webpack_public_path__ + "img/info.c46b00c0.png";